import { ButtonLink } from '@getslot/ui-web/button'
import { NavItem } from '@getslot/ui-web/bottom-nav'
import { ListRowLink } from '@getslot/ui-web/list'
import { SideNavItem } from '@getslot/ui-web/side-nav'
import { createLink } from '@tanstack/react-router'

// Компоненты ui-web не знают о роутере: здесь они становятся ссылками TanStack Router.
export const RouterButtonLink = createLink(ButtonLink)
export const RouterNavItem = createLink(NavItem)
export const RouterListRowLink = createLink(ListRowLink)
export const RouterSideNavItem = createLink(SideNavItem)
